import { render, staticRenderFns } from "./FormCreateResearchPage4.vue?vue&type=template&id=51909885&scoped=true&"
import script from "./FormCreateResearchPage4.vue?vue&type=script&lang=js&"
export * from "./FormCreateResearchPage4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51909885",
  null
  
)

export default component.exports